export interface ScreensaverCacheResult {
  ok: boolean;
  cached: number;
  failed: Array<{ url: string; error: string }>;
}

const CACHE_TIMEOUT_MS = 5 * 60 * 1000;

export const cacheScreensaverMedia = async (urls: string[]): Promise<ScreensaverCacheResult> => {
  const uniqueUrls = [...new Set(urls.filter(Boolean))];

  if (!('serviceWorker' in navigator)) {
    return {
      ok: false,
      cached: 0,
      failed: [{ url: '', error: 'Cache persistente no compatible con este navegador' }],
    };
  }

  try {
    if ('storage' in navigator && 'persist' in navigator.storage) {
      await navigator.storage.persist().catch(() => false);
    }

    const registration = await navigator.serviceWorker.register('/screensaver-sw.js', {
      scope: '/',
      updateViaCache: 'none',
    });
    await navigator.serviceWorker.ready;
    const worker = registration.active ?? registration.waiting ?? registration.installing;
    if (!worker) throw new Error('El service worker del salvapantallas no está disponible');

    return await new Promise<ScreensaverCacheResult>((resolve) => {
      const channel = new MessageChannel();
      const timeoutId = window.setTimeout(() => {
        channel.port1.close();
        resolve({
          ok: false,
          cached: 0,
          failed: [{ url: '', error: 'Tiempo de caché agotado' }],
        });
      }, CACHE_TIMEOUT_MS);

      channel.port1.onmessage = (event: MessageEvent<ScreensaverCacheResult>) => {
        window.clearTimeout(timeoutId);
        channel.port1.close();
        resolve(event.data);
      };

      worker.postMessage(
        { type: 'CACHE_SCREENSAVER_MEDIA', urls: uniqueUrls },
        [channel.port2],
      );
    });
  } catch (error) {
    return {
      ok: false,
      cached: 0,
      failed: [{ url: '', error: error instanceof Error ? error.message : String(error) }],
    };
  }
};
